

















import { Vue, Component } from 'vue-property-decorator'
import { EPLModule } from '@/store/eplmodule'

@Component({ name: 'AppFooter' })
export default class AppFooter extends Vue {
  mounted (): void {
    const theme = localStorage.getItem('Theme')
    this.$vuetify.theme.dark = theme === 'dark'
  }

  get version () {
    const version = process.env.VUE_APP_VERSION
    if (version === undefined) return `v: ${EPLModule.versionbg} - ${EPLModule.versionfg}`
    else return `v: ${EPLModule.versionbg} - ${version}`
  }

  private changeTheme (): void {
    this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    if (this.$vuetify.theme.dark) localStorage.setItem('Theme', 'dark')
    else localStorage.setItem('Theme', 'light')
  }
}
